import { Box, TabMenu, TabMenuItem } from "@bcc-ui/ui-components";
import { useFeature } from "flagged";
import { t } from "i18next";
import React from "react";

import style from "./shared-settings-subpage.scss";
import { ReportCustomizationForm } from "components/settings/views/shared-settings/report-customization-form/ReportCustomizationForm";
import { SharedSettingsForm } from "components/settings/views/shared-settings/shared-settings-form/SharedSettingsForm";
import { AUTH_SIGNATURE_KEY_VIEW, AUTH_TENANT_SETTINGS } from "domain/authority";
import { FLAG_REPORT_SIGNATURE_KEYS } from "services/feature/FeatureFlagService";
import { userSessionService } from "services/user/UserSessionService";

import testIds from "testIds.json";

export const SharedSettingsSubpage = () => {
    const [activeTab, setActiveTab] = React.useState(0);

    const isReportSignatureKeysFeatureEnabled = useFeature(FLAG_REPORT_SIGNATURE_KEYS);
    const hasCustomLogoAuth = userSessionService.userHasAllAuthorities([AUTH_TENANT_SETTINGS]);
    const hasReportSignatureKeysAuth =
        isReportSignatureKeysFeatureEnabled && userSessionService.userHasAllAuthorities([AUTH_SIGNATURE_KEY_VIEW]);

    const tabs = [
        {
            label: "Common.general",
            key: 0,
            testId: testIds.workArea.settings.shared.tabs.generalTab,
        },
    ];

    if (hasCustomLogoAuth || hasReportSignatureKeysAuth) {
        tabs.push({
            label: "Settings.reportCustomization",
            key: 1,
            testId: testIds.workArea.settings.shared.tabs.reportCustomizationTab,
        });
    }

    const renderTabContent = () => {
        switch (activeTab) {
            case 0:
                return <SharedSettingsForm />;
            case 1:
                return <ReportCustomizationForm />;
            default:
                return null;
        }
    };

    return (
        <Box columnLayout className={style.viewContainer}>
            <TabMenu>
                {tabs.map((tab) => (
                    <TabMenuItem
                        key={tab.key}
                        isActive={activeTab === tab.key}
                        onClick={() => setActiveTab(tab.key)}
                        testId={tab.testId}
                    >
                        {t(tab.label)}
                    </TabMenuItem>
                ))}
            </TabMenu>
            {renderTabContent()}
        </Box>
    );
};
